module.exports = __webpack_public_path__ + "img/titlevi.61f11e21.png";